// Import model
import { FindRoomSelectionRequest } from '../models/FindRoomSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FindRoomSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class FindRoomSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a FindRoomSelectionRequest instance
   */
  static deserialize(json: string): FindRoomSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FindRoomSelectionRequest instance
   */
  static fromObject(obj: any): FindRoomSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FindRoomSelectionRequest');
    }


    const instance: FindRoomSelectionRequest = {
      binId: obj['binId'] as string,
      description: obj['description'] as string,
      itemId: obj['itemId'] as string,
      itemIdName: obj['itemId|Name'] as string | undefined,
      name: obj['name'] as string,
      projectExternalId: obj['projectExternalId'] as string,
      projectExternalIdName: obj['projectExternalId|Name'] as string | undefined,
      roomIds: obj['roomIds'] ? (obj['roomIds'] as any[]).map((item: any) =>
        item as string
      ) : [],
      sessionKey: obj['sessionKey'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FindRoomSelectionRequest instances
   */
  static deserializeArray(json: string): FindRoomSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FindRoomSelectionRequest instance to a JSON string
   */
  static serialize(instance: FindRoomSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FindRoomSelectionRequest instance to a plain object
   */
  static toObject(instance: FindRoomSelectionRequest): any {
    return {
      'binId': instance.binId,
      'description': instance.description,
      'itemId': instance.itemId,
      'itemId|Name': instance.itemIdName,
      'name': instance.name,
      'projectExternalId': instance.projectExternalId,
      'projectExternalId|Name': instance.projectExternalIdName,
      'roomIds': instance.roomIds?.map((item: any) =>
        item
      ),
      'sessionKey': instance.sessionKey,
    };
  }

  /**
   * Serializes an array of FindRoomSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: FindRoomSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
